import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { getDate } from '../../appointments/appointmentSelector';
import { getStartOfDay } from '../../../common/helpers/times';
import withFetchTimeTrackingBarbers from './withFetchTimeTrackingBarbers';

const sideBySideFetchTimeTracking = compose(
  withFetchTimeTrackingBarbers,
  connect(
    state => ({
      currentDate: getDate(state),
      timezone: state.auth.timezone,
    }),
  ),
  withHandlers({
    fetchTimeTracking: props => () => {
      const { timezone, currentDate } = props;
      const filters = {
        startedAt__gte: getStartOfDay(timezone, currentDate).toJSON(),
        startedAt__lte: getStartOfDay(timezone, currentDate).endOf('day').toJSON(),
      };
      props.fetchTimeTrackingBarbers(filters);
    },
  }),
);

export default sideBySideFetchTimeTracking;
